import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { Link, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Container, Row, Col, Alert, Form, FormGroup, Input, Button, Label, Spinner } from 'reactstrap';
import { errorMessages } from '../constants/messages';
import logo from '../assets/images/myMetlife-logo.png';
import Footer from './UI/Footer';

const SSORegisterForm = ({ error, loading, success, message, onFormSubmit, defaultValues, counter }) => {
  const { register, handleSubmit, errors, setValue } = useForm({ defaultValues });

  const minutes = Math.floor(counter / 60);
  const seconds = counter % 60;
  const formatedtime = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

  useEffect(() => {
    setValue('showemail', defaultValues.email);
    setValue('token', defaultValues.authToken);
  }, [defaultValues]);

  return (
    <div className="bg-g">
      <Helmet>
        <title>Register</title>
      </Helmet>
      <Container className="register full-width-page">
        <Row className="text-center h-100 align-content-center">
          <Col className="text-center login-left">
            <img className="logo" src={logo} alt="" />
            <h1>Registration</h1>
            {counter ? (
              <>
                <h3>Enter the below information to complete the registration</h3>
                <h3>{`This session will expire in ${formatedtime}`}</h3>
              </>
            ) : (
              <Alert color="danger">Time's up!. Please try again later.</Alert>
            )}
            {!!success && <Alert color="success">{message}</Alert>}
            {!!error && <Alert color="danger">{message}</Alert>}
            <Form onSubmit={handleSubmit(onFormSubmit)}>
              <FormGroup className="mt-3 form-label-group">
                <Input
                  type="text"
                  name="policy_number"
                  id="policy_number"
                  autoComplete="off"
                  placeholder="Policy Number"
                  disabled={loading}
                  invalid={!!errors.policy_number}
                  innerRef={register({ required: errorMessages.invalidPolicyNumber })}
                  onChange={(e) => setValue('policy_number', e.target.value)}
                />
                <Label>Policy Number</Label>
                {errors.policy_number && <p className="invalid-feedback">{errors.policy_number.message}</p>}
              </FormGroup>
              <FormGroup className="form-label-group">
                <Input
                  type="text"
                  name="certificate_number"
                  id="certificate_id"
                  autoComplete="off"
                  placeholder="Certificate Number"
                  disabled={loading}
                  invalid={!!errors.certificate_number}
                  innerRef={register({ required: errorMessages.invalidCertificateNumber })}
                  onChange={(e) => setValue('certificate_number', e.target.value)}
                />
                <Label>Certificate Number</Label>
                {errors.certificate_number && <p className="invalid-feedback">{errors.certificate_number.message}</p>}
              </FormGroup>
              <FormGroup className="form-label-group">
                <Input
                  type="date"
                  name="dob"
                  id="dob"
                  placeholder="dd/mm/yyyy"
                  className="form-control placeholder"
                  autoComplete="off"
                  disabled={loading}
                  max={new Date().toJSON().slice(0, 10)}
                  invalid={!!errors.dob}
                  innerRef={register({ required: errorMessages.dobMissing })}
                  onChange={(e) => {
                    setValue('dob', e.target.value);
                  }}
                  onClick={(e) => {
                    e.target.showPicker();
                    e.target.classList.add('active');
                  }}
                  style={{ width: '100% !important' }}
                />
                <Label>Date Of Birth</Label>
                {errors.dob && <p className="invalid-feedback">{errors.dob.message}</p>}
              </FormGroup>
              <FormGroup className="form-label-group">
                <Input
                  type="text"
                  name="showemail"
                  id="email"
                  placeholder="Email"
                  disabled
                  invalid={!!errors.email}
                  innerRef={register({
                    required: errorMessages.invalidEmail,
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: errorMessages.invalidEmail,
                    },
                  })}
                />
                <Label>Email</Label>
                {errors.email && <p className="invalid-feedback">{errors.email.message}</p>}
              </FormGroup>
              <FormGroup className="form-label-group">
                <Input type="hidden" name="token" id="token" disabled invalid={!!errors.email} innerRef={register()} />
              </FormGroup>
              <Button color="primary" disabled={loading || !counter} style={{ width: '100%' }}>
                {loading || !counter ? (
                  !counter ? (
                    'Timed out!'
                  ) : (
                    <>
                      <Spinner size="sm" color="light" />
                      <span>&nbsp;Loading</span>
                    </>
                  )
                ) : (
                  'Register'
                )}
              </Button>
            </Form>
            <div className="bottom-links justify-content-center  mt-5">
              Already Registered?
              <Link to="/login" className="text-primary">
                {' '}
                Log in
              </Link>
            </div>
            <div className="bottom-links justify-content-center  mt-3">
              <Link to="/faq" className="text-primary">
                Hi, Need Any Help?
              </Link>
            </div>
          </Col>
          <Col className="text-center login-right text-white p-5">
            <h2 className="">Introducing myMetLife Plus</h2>
            <p className="">
              myMetLife Plus is a one-stop online customer service center with everything MetLife has to offer! Manage
              your account, read the latest on health, fitness, and financial wellness, and access customer service-
              anytime, anywhere from your computer, phone or tablet, providers - with plans designed to help manage
              out-of- pocket expenses. Now, that's something to smile about.
            </p>
          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  );
};

SSORegisterForm.propTypes = {
  error: PropTypes.bool,
  loading: PropTypes.bool,
  success: PropTypes.bool,
  message: PropTypes.string,
  counter: PropTypes.number.isRequired,
  defaultValues: PropTypes.shape({
    email: PropTypes.string,
    authToken: PropTypes.string,
  }),
  onFormSubmit: PropTypes.func.isRequired,
};

SSORegisterForm.defaultProps = {
  error: null,
  success: null,
  message: null,
  loading: false,
  defaultValues: {},
};

export default withRouter(SSORegisterForm);
